"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var instructor_create_student_html_1 = __importDefault(require("./instructor-create-student.html"));
var instructor_create_student_controller_1 = __importDefault(require("./instructor-create-student.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.createstudent", {
        url: "/create-student",
        controller: instructor_create_student_controller_1.default,
        controllerAs: "vm",
        template: instructor_create_student_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.createstudent", [])
    .config(config)
    .controller("InstructorCreateStudentController", instructor_create_student_controller_1.default);
